import { useMemo } from "react";

import { typedQueryClient } from "hooks";
import { HoldingsQueryKeys } from "modules/HoldingsDashboard/queryKeys";

import type { WebSocketMessageListener } from "components";
import type { Holding } from "models";

export const useHoldingsListeners = () =>
  useMemo(() => {
    const holdingsListeners: WebSocketMessageListener<Holding>[] = [
      {
        model: "Holding",
        action: "upsert",
        callback: ({ data: holding }) => {
          const holdings = typedQueryClient.getQueryData(HoldingsQueryKeys.list);
          const holdingIdx = holdings?.findIndex(h => h.id === holding.id) ?? -1;
          const updatedHoldings = [...(holdings ?? [])];

          typedQueryClient.setQueryData(
            HoldingsQueryKeys.list,
            holdingIdx === -1 ? [...updatedHoldings, holding] : updatedHoldings.with(holdingIdx, { ...updatedHoldings[holdingIdx], ...holding })
          );
        }
      },
      {
        model: "Holding",
        action: "delete",
        callback: ({ data: holding }) => {
          const holdings = typedQueryClient.getQueryData(HoldingsQueryKeys.list);
          if (!holdings?.length) return;

          const holdingIdx = holdings.findIndex(h => h.id === holding.id);
          if (holdingIdx === -1) return;

          typedQueryClient.setQueryData(HoldingsQueryKeys.list, holdings.toSpliced(holdingIdx, 1));
        }
      }
    ];

    return holdingsListeners;
  }, []);
